
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ColorPalette } from "@lighting-beetle/lighter-styleguide";
import { colors } from "./../tokens";
import { getPaletteFromColors } from "./../utils";
import Grid, { GridCol } from "./../components/Grid/index";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Color Palette`}</h1>
    <p>{`This is Color Palette documentation`}</p>
    <Grid mdxType="Grid">
  <GridCol size={{
        m: 6
      }} mdxType="GridCol">
    <div className="h4">Primary colors</div>
    <ColorPalette color={getPaletteFromColors(colors.primary)} name="primary" mdxType="ColorPalette" />
  </GridCol>
  <GridCol size={{
        m: 6
      }} mdxType="GridCol">
    <div className="h4">Secondary colors</div>
    <ColorPalette color={getPaletteFromColors(colors.secondary)} name="secondary" mdxType="ColorPalette" />
  </GridCol>
  <GridCol size={{
        m: 6
      }} mdxType="GridCol">
    <div className="h4">Error colors</div>
    <ColorPalette color={getPaletteFromColors(colors.error)} name="error" mdxType="ColorPalette" />
  </GridCol>
  <GridCol size={{
        m: 6
      }} mdxType="GridCol">
    <div className="h4">Success colors</div>
    <ColorPalette color={getPaletteFromColors(colors.success)} name="success" mdxType="ColorPalette" />
  </GridCol>
  <GridCol size={{
        m: 6
      }} mdxType="GridCol">
    <div className="h4">Grey colors</div>
    <ColorPalette color={getPaletteFromColors(colors.grey)} name="grey" mdxType="ColorPalette" />
  </GridCol>
    </Grid>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;